export default __webpack_public_path__ + "static/media/NarutoOriginal.e1d5d106.webp";